import { z } from 'zod';

/**
 * Schema for the core AuthUser model from Firebase Authentication.
 * Uses readonly modifiers for data integrity.
 */
const AuthUserSchema = z.object({
  uid: z.string().min(1, { message: "UID is required" }),
  email: z.email({ message: "A valid email is required" }).nullable().optional(),
  displayName: z.string().nullable().optional(),
  photoURL: z.url({ message: "A valid URL is required for photoURL" }).nullable().optional(),
  emailVerified: z.boolean().default(false),
  isAnonymous: z.boolean().default(false),
}).strict();

export type AuthUserType = z.infer<typeof AuthUserSchema>;

export default AuthUserSchema; 